import { withAsync } from '../behaviors/async';
import Typeahead from './Typeahead';
export default withAsync(Typeahead);